// Ce fichier est généré automatiquement par scripts/generate-service-registers.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:service-registers

// ================================
// IMPORTS DES SERVICES
// ================================
import { AlarmesV2Service } from "./alarmes-v2.service"

// ================================
// EXPORTS DES SERVICES
// ================================
export * from "./alarmes-v2.service"

// ================================
// REGISTRY DES SERVICES
// ================================
export const alarmesV2ServiceRegistry = {
    alarmesV2: new AlarmesV2Service(),
} as const

// ================================
// TYPES DU REGISTRY
// ================================
export type AlarmesV2ServiceRegistry = typeof alarmesV2ServiceRegistry
